export enum ROLE_STATUS_ENUM {
  ACTIVE = 'Activo',
  DELETED = 'Eliminado'
}

export enum ROLE_STATUS_COLOR_ENUM {
  ACTIVE = 'primary',
  DELETED = 'danger'
}
